import {
  LOCAL_TRAIL_COUNT_REQ,
  LOCAL_TRAIL_COUNT_SUCCESS,
  LOCAL_TRAIL_COUNT_ERROR,
  LOCAL_TRAIL_COUNT_SET,
  LOCAL_TRAIL_COUNT_RESET_STATUS,
  AGENT_LOCAL_TRAIL_COUNT_REQ,
  AGENT_LOCAL_TRAIL_COUNT_SUCCESS,
  AGENT_LOCAL_TRAIL_COUNT_ERROR,
  AGENT_LOCAL_TRAIL_COUNT_SET,
  AGENT_LOCAL_TRAIL_COUNT_RESET_STATUS
} from './trail-statistics.type'

import ApiRest from '@/api/api-rest'

const state = {
  localTrailCountReqStatus: '',
  localTrailCount: 0,
  agentLocalTrailCountReqStatus: '',
  agentLocalTrailCount: 0
}

const getters = {
  localTrailCountReqStatus: state => state.localTrailCountReqStatus,
  localTrailCount: state => state.localTrailCount,
  agentLocalTrailCountReqStatus: state => state.agentLocalTrailCountReqStatus,
  agentLocalTrailCount: state => state.agentLocalTrailCount
}

const mutations = {
  [LOCAL_TRAIL_COUNT_SET]: (state, data) => {
    state.localTrailCount = data
  },
  [LOCAL_TRAIL_COUNT_REQ]: state => {
    state.localTrailCountReqStatus = 'loading'
  },
  [LOCAL_TRAIL_COUNT_SUCCESS]: state => {
    state.localTrailCountReqStatus = 'saved'
  },
  [LOCAL_TRAIL_COUNT_ERROR]: state => {
    state.localTrailCountReqStatus = 'error'
  },
  [LOCAL_TRAIL_COUNT_RESET_STATUS]: state => {
    state.localTrailCountReqStatus = ''
  },
  [AGENT_LOCAL_TRAIL_COUNT_SET]: (state, data) => {
    state.agentLocalTrailCount = data
  },
  [AGENT_LOCAL_TRAIL_COUNT_REQ]: state => {
    state.agentLocalTrailCountReqStatus = 'loading'
  },
  [AGENT_LOCAL_TRAIL_COUNT_SUCCESS]: state => {
    state.agentLocalTrailCountReqStatus = 'saved'
  },
  [AGENT_LOCAL_TRAIL_COUNT_ERROR]: state => {
    state.agentLocalTrailCountReqStatus = 'error'
  },
  [AGENT_LOCAL_TRAIL_COUNT_RESET_STATUS]: state => {
    state.agentLocalTrailCountReqStatus = ''
  }
}

const actions = {
  [LOCAL_TRAIL_COUNT_REQ] (context, dateRangeSel) {
    return new Promise((resolve, reject) => {
      context.commit(LOCAL_TRAIL_COUNT_REQ)
      ApiRest()
        .post('/bi/trail/count', {
          date_range: dateRangeSel
        })
        .then(({ data }) => {
          context.commit(LOCAL_TRAIL_COUNT_SET, data)
          resolve(data)
        })
        .catch(errMsg => {
          context.commit(LOCAL_TRAIL_COUNT_ERROR, errMsg)
          reject(errMsg)
        })
    })
  },
  [LOCAL_TRAIL_COUNT_SUCCESS] (context) {
    context.commit(LOCAL_TRAIL_COUNT_SUCCESS)
  },
  [LOCAL_TRAIL_COUNT_RESET_STATUS] (context) {
    context.commit(LOCAL_TRAIL_COUNT_RESET_STATUS)
  },
  [AGENT_LOCAL_TRAIL_COUNT_REQ] (context, agentId) {
    return new Promise((resolve, reject) => {
      context.commit(AGENT_LOCAL_TRAIL_COUNT_REQ)
      ApiRest()
        .get(`/bi/trail/count/${agentId}`)
        .then(({ data }) => {
          context.commit(AGENT_LOCAL_TRAIL_COUNT_SET, data)
          resolve(data)
        })
        .catch(errMsg => {
          context.commit(AGENT_LOCAL_TRAIL_COUNT_ERROR, errMsg)
          reject(errMsg)
        })
    })
  },
  [AGENT_LOCAL_TRAIL_COUNT_SUCCESS] (context) {
    context.commit(AGENT_LOCAL_TRAIL_COUNT_SUCCESS)
  },
  [AGENT_LOCAL_TRAIL_COUNT_RESET_STATUS] (context) {
    context.commit(AGENT_LOCAL_TRAIL_COUNT_RESET_STATUS)
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/dashboard/trail-statistics.module.js